import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ListingFragmentFragment = { __typename?: 'Listing' } & Pick<
    Types.Listing,
    | 'numberOfVideos'
    | 'numberOfImages'
    | 'numberOfFloorPlans'
    | 'numberOfViews'
    | 'listingId'
    | 'title'
    | 'publishedOnLabel'
    | 'publishedOn'
    | 'availableFrom'
    | 'isPremium'
    | 'flag'
    | 'priceTitle'
    | 'shortPriceTitle'
    | 'price'
    | 'address'
> & {
        priceDrop?: Types.Maybe<
            { __typename?: 'PriceDrop' } & Pick<
                Types.PriceDrop,
                'lastPriceChangeDate' | 'percentageChangeLabel'
            >
        >;
        highlights?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Highlight' } & Pick<
                        Types.Highlight,
                        'description' | 'label' | 'url'
                    >
                >
            >
        >;
        otherPropertyImages?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'SubImage' } & Pick<
                        Types.SubImage,
                        'small' | 'large' | 'caption'
                    >
                >
            >
        >;
        branch?: Types.Maybe<
            { __typename?: 'Branch' } & Pick<
                Types.Branch,
                'name' | 'branchDetailsUri' | 'phone' | 'logoUrl'
            >
        >;
        features?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Feature' } & Pick<
                        Types.Feature,
                        'content' | 'iconId'
                    >
                >
            >
        >;
        image?: Types.Maybe<
            { __typename?: 'Image' } & Pick<Types.Image, 'src' | 'caption'> & {
                    responsiveImgList?: Types.Maybe<
                        Array<
                            Types.Maybe<
                                { __typename?: 'ResponsiveImg' } & Pick<
                                    Types.ResponsiveImg,
                                    'width' | 'src'
                                >
                            >
                        >
                    >;
                }
        >;
        transports?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Transport' } & Pick<
                        Types.Transport,
                        'title' | 'poiType' | 'distanceInMiles'
                    > & {
                            features?: Types.Maybe<
                                { __typename?: 'TransportFeatures' } & Pick<
                                    Types.TransportFeatures,
                                    'zone' | 'tubeLines'
                                >
                            >;
                        }
                >
            >
        >;
        tags?: Types.Maybe<
            Array<
                Types.Maybe<{ __typename?: 'Tag' } & Pick<Types.Tag, 'content'>>
            >
        >;
        listingUris?: Types.Maybe<
            { __typename?: 'ListingUris' } & Pick<
                Types.ListingUris,
                'contact' | 'detail'
            >
        >;
        location?: Types.Maybe<
            { __typename?: 'ListingLocation' } & {
                coordinates?: Types.Maybe<
                    { __typename?: 'LocationCoordinates' } & Pick<
                        Types.LocationCoordinates,
                        'latitude' | 'longitude'
                    >
                >;
            }
        >;
    };

export type GetListingMapViewQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingMapViewQuery = { __typename?: 'Query' } & {
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<Types.Results, 'polyenc'> & {
                analyticsTaxonomy?: Types.Maybe<
                    { __typename?: 'AnalyticsTaxonomy' } & Pick<
                        Types.AnalyticsTaxonomy,
                        | 'activity'
                        | 'areaName'
                        | 'bedsMax'
                        | 'bedsMin'
                        | 'brand'
                        | 'countryCode'
                        | 'countyAreaName'
                        | 'currencyCode'
                        | 'emailAllFormShown'
                        | 'emailAllTotalAgents'
                        | 'expandedResultsCount'
                        | 'listingsCategory'
                        | 'location'
                        | 'outcode'
                        | 'outcodes'
                        | 'page'
                        | 'postalArea'
                        | 'priceMax'
                        | 'priceMin'
                        | 'propertyType'
                        | 'radius'
                        | 'radiusAutoexpansion'
                        | 'regionName'
                        | 'resultsSort'
                        | 'searchGuid'
                        | 'searchIdentifier'
                        | 'searchLocation'
                        | 'searchResultsCount'
                        | 'section'
                        | 'totalResults'
                        | 'url'
                        | 'viewType'
                        | 'geoIdentifier'
                    >
                >;
                analyticsEcommerce?: Types.Maybe<
                    { __typename?: 'AnalyticsEcommerce' } & Pick<
                        Types.AnalyticsEcommerce,
                        'currencyCode'
                    > & {
                            impressions?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'AnalyticsEcommerceImpressions';
                                        } & Pick<
                                            Types.AnalyticsEcommerceImpressions,
                                            | 'id'
                                            | 'list'
                                            | 'position'
                                            | 'variant'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Pick<
                        Types.Meta,
                        'title' | 'description' | 'canonicalUri'
                    >
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pick<
                        Types.Pagination,
                        'pageNumber' | 'totalResults' | 'totalResultsWasLimited'
                    >
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & ListingFragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & ListingFragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & ListingFragmentFragment
                                >
                            >
                        >;
                    }
                >;
                filters?: Types.Maybe<
                    { __typename?: 'Filters' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'FiltersFields' } & Pick<
                                        Types.FiltersFields,
                                        | 'group'
                                        | 'fieldName'
                                        | 'label'
                                        | 'isRequired'
                                        | 'inputType'
                                        | 'placeholder'
                                        | 'allowMultiple'
                                        | 'options'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                    }
                >;
                sortOrder?: Types.Maybe<
                    { __typename?: 'SortOrder' } & Pick<
                        Types.SortOrder,
                        'currentSortOrder'
                    > & {
                            options?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'SortOrderOption';
                                        } & Pick<
                                            Types.SortOrderOption,
                                            'i18NLabelKey' | 'value'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Pick<
                        Types.SeoBlurb,
                        'category' | 'transactionType'
                    >
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Pick<
                        Types.Links,
                        'saveSearch' | 'createAlert'
                    >
                >;
                polygonV2?: Types.Maybe<
                    { __typename?: 'Polygon' } & Pick<
                        Types.Polygon,
                        'polygons' | 'radius' | 'geoType'
                    > & {
                            geoData?: Types.Maybe<
                                { __typename?: 'GeoData' } & Pick<
                                    Types.GeoData,
                                    'coordinates'
                                >
                            >;
                        }
                >;
            }
    >;
};

export const ListingFragmentFragmentDoc = gql`
    fragment listingFragment on Listing {
        numberOfVideos
        numberOfImages
        numberOfFloorPlans
        numberOfViews
        listingId
        title
        publishedOnLabel
        publishedOn
        availableFrom
        priceDrop {
            lastPriceChangeDate
            percentageChangeLabel
        }
        isPremium
        highlights {
            description
            label
            url
        }
        otherPropertyImages {
            small
            large
            caption
        }
        branch {
            name
            branchDetailsUri
            phone
            logoUrl
        }
        features {
            content
            iconId
        }
        image {
            src
            caption
            responsiveImgList {
                width
                src
            }
        }
        transports {
            title
            poiType
            distanceInMiles
            features {
                zone
                tubeLines
            }
        }
        flag
        listingId
        priceTitle
        shortPriceTitle
        price
        address
        tags {
            content
        }
        listingUris {
            contact
            detail
        }
        location {
            coordinates {
                latitude
                longitude
            }
        }
    }
`;
export const GetListingMapViewDocument = gql`
    query getListingMapView($path: String!) {
        searchResults(path: $path) {
            analyticsTaxonomy {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                countryCode
                countyAreaName
                currencyCode
                emailAllFormShown
                emailAllTotalAgents
                expandedResultsCount
                listingsCategory
                location
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
                geoIdentifier
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                totalResults
                totalResultsWasLimited
            }
            listings {
                regular {
                    ...listingFragment
                }
                featured {
                    ...listingFragment
                }
                extended {
                    ...listingFragment
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            links {
                saveSearch
                createAlert
            }
            polygonV2(path: $path) {
                polygons
                radius
                geoData {
                    coordinates
                }
                geoType
            }
            polyenc
        }
    }
    ${ListingFragmentFragmentDoc}
`;

/**
 * __useGetListingMapViewQuery__
 *
 * To run a query within a React component, call `useGetListingMapViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingMapViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingMapViewQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingMapViewQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >(GetListingMapViewDocument, options);
}
export function useGetListingMapViewLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >(GetListingMapViewDocument, options);
}
export type GetListingMapViewQueryHookResult = ReturnType<
    typeof useGetListingMapViewQuery
>;
export type GetListingMapViewLazyQueryHookResult = ReturnType<
    typeof useGetListingMapViewLazyQuery
>;
export type GetListingMapViewQueryResult = Apollo.QueryResult<
    GetListingMapViewQuery,
    GetListingMapViewQueryVariables
>;
